import React from 'react';

interface InputTabProps {
    /** CSV header derived from the selected functions' input fields (read-only). */
    csvHeader: string;
    csvRows: string;
    onCsvRowsChange: (value: string) => void;
}

/** Step 2: provide the CSV rows to process. The header is fixed by the chain. */
const InputTab: React.FC<InputTabProps> = ({ csvHeader, csvRows, onCsvRowsChange }) => (
    <div className="batcher-panel">
        <div className="batcher-input-body">
            <div className="batcher-input-field">
                <label className="batcher-input-label" htmlFor="batcher-csv-header">
                    CSV header (columns)
                </label>
                <p className="batcher-input-hint">
                    Determined by the selected functions&apos; required fields.
                </p>
                <input
                    id="batcher-csv-header"
                    type="text"
                    className="batcher-csv-header"
                    value={csvHeader}
                    readOnly
                />
            </div>

            <div className="batcher-input-field">
                <label className="batcher-input-label" htmlFor="batcher-csv-rows">
                    CSV rows
                </label>
                <p className="batcher-input-hint">
                    One row per line, values comma-separated in the same order as the header above.
                </p>
                <textarea
                    id="batcher-csv-rows"
                    className="batcher-csv-rows"
                    value={csvRows}
                    onChange={e => onCsvRowsChange(e.target.value)}
                    placeholder={csvHeader ? `${csvHeader.split(',').map(() => 'value').join(',')}` : 'value1,value2,value3'}
                    rows={12}
                />
            </div>
        </div>
    </div>
);

export default InputTab;
